<template>
  <div class="container">
    <van-skeleton title :row="15" :loading="loading">
      <table></table>
      <h3 :class="{ top: isapp }">{{ obj.title }}</h3>
      <div class="intro">
        <div>
          <p>来源：{{ obj.from }}</p>
          <p>发布人：{{ obj.org_name }}</p>
        </div>
        <p>发布日期：{{ obj.post_date }}</p>
      </div>
      <div class="main" v-html="obj.content"></div>
      <div class="bottomdiv" v-if="isapp">
        <div
          style="
            text-align: right;
            line-height: 40px;
            height: 40px;
            color: white;
            margin-right: 10px;
          "
          @click="openShare(obj.title, obj.id, obj.img)"
        >
          <van-icon name="share-o" />
          <span>分享</span>
        </div>
      </div>
    </van-skeleton>
  </div>
</template>
<script>
export default {
  name: "newsdetail",
  data() {
    return {
      obj: {},
      loading: true,
      appId: "2312",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      isapp: false,
    };
  },
  created() {
    var browser = {
      versions: (function () {
        var u = navigator.userAgent;
        return {
          trident: u.indexOf("Trident") > -1,
          presto: u.indexOf("Presto") > -1,
          webKit: u.indexOf("AppleWebKit") > -1,
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
          iPhone: u.indexOf("iPhone") > -1,
          iPad: u.indexOf("iPad") > -1,
          webApp: u.indexOf("Safari") == -1,
          uc:
            (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) &&
            u.indexOf("UCBrowser") > -1,
          weixin: u.toLowerCase().match(/MicroMessenger/i) == "micromessenger", //判断微信
          iosApp: u.match(/ByIphone/i) != null, //判断ios版app
          androidApp: u.match(/ByAndroid/i) != null, //判断android版app
          iPhoneOs:
            u.indexOf("iPhone") > -1 && u.indexOf("Mobile") > -1
              ? /CPU (?:iPhone )?OS (\d+_\d+)/.test(u)
                ? parseFloat(RegExp.$1.replace("_", "."))
                : 2
              : null, //返回ios版本号
        };
      })(),
    };
    if (!browser.versions.iosApp && !browser.versions.androidApp) {
      //如果不在app中打开
      console.log("未在APP中打开");
      this.isapp = false;
    } else {
      this.isapp = true;
      var that = this;
      zjyapi.init({
        appId: that.appId,
        error: function (code, ret) {
          //失败回调,默认
          alert("初始化失败");
        },
        success: function success(ret) {},
      });
    }
    console.log("id:" + this.$route.query.id);
    this.$axios({
      method: "post",
      url: "/api/news/info",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
        zjy_uid: sessionStorage.getItem("uid"),
        id: this.$route.query.id,
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.obj = res.data.data;
      } else {
        this.$toast(res.data.msg);
      }
      this.loading = false;
    });
  },
  updated() {
    let img = document.querySelectorAll("img"); //获取所有图片
    for (let i = 0; i < img.length; i++) {
      const element = img[i];
      //添加样式
      element.style.width = "100%";
      element.style.margin = "10px auto";
      element.style.display = "block";
    }
  },
  methods: {
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, id, img) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: title,
            content: "我在看大家参与" + title + "的图文及心得，你也快来看一看",
            url: "https://www.jywmsj.cn/h5/#/newsdetail?id=" + id, //分享地址
            imgUrl: img, //分享图标地址
          },
          success: function (ret) {
            console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            console.log(ret);
            console.log(data);
          },
          error: function (error) {
            that.$toast("分享失败");
            console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
  },
};
</script>
<style scoped>
.container {
  padding: 20px;
}
h3 {
  text-align: center;
  margin: 0 auto;
}
img {
  width: 95vw !important;
  display: block;
  margin: 10px 0;
}
.main {
  margin-top: 20px;
  line-height: 2em;
}

.intro {
  font-size: 12px;
  color: grey;
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.container /deep/ video {
  width: 100%;
  margin: 10px 0;
  display: block;
}
.container /deep/ iframe {
  width: 100% !important;
  height: 55vw !important;
}
.bottomdiv {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #c7b58b;
}
.top {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/newsdetail.vue